import {
  RESET_CAPACITY_STARTED,
  RESET_CAPACITY_QUEUED,
  RESET_CAPACITY_ITEM_STARTED,
  RESET_CAPACITY_ITEM_COMPLETED,
  RESET_CAPACITY_ITEM_FAILED,
  RESET_CAPACITY_FINALIZING,
  RESET_CAPACITY_ALL_COMPLETED,
  RESET_CAPACITY_ALL_FAILED,
  RESET_CAPACITY_REQUEST_FAILED,
  RESET_CAPACITY_JOB_DISMISS,
} from "../types";
import { startResetCapacityWebSocket } from "./ResetCapacityWebSocketService";

function readEtaSeconds(frame) {
  return (
    frame?.etaSecondsRemaining ??
    frame?.estimatedRemainingSeconds ??
    frame?.remainingSeconds ??
    frame?.etaSeconds ??
    null
  );
}

export const resetCapacityDismiss = (jobId = "all") => ({
  type: RESET_CAPACITY_JOB_DISMISS,
  payload: { jobId },
});

export const startResetCapacity = () => (dispatch) => {
  let _jobId = null;

  startResetCapacityWebSocket({
    onJobStarted: ({ jobId, topic }) => {
      _jobId = jobId;
      dispatch({
        type: RESET_CAPACITY_STARTED,
        payload: { jobId, topic, startedAt: 0 },
      });
    },

    onQueued: (frame) =>
      dispatch({
        type: RESET_CAPACITY_QUEUED,
        payload: {
          jobId: _jobId,
          total: frame.total,
          projects: frame.projects,
          etaSeconds: readEtaSeconds(frame),
          avgSecondsPerWeight: frame.avgSecondsPerWeight,
        },
      }),

    onItemStarted: (frame) =>
      dispatch({
        type: RESET_CAPACITY_ITEM_STARTED,
        payload: {
          jobId: _jobId,
          index: frame.itemIndex ?? frame.current,
          label: frame.itemLabel ?? frame.resourceName ?? frame.resourceCode ?? "",
          startedAt: frame.startedAt,
          etaSeconds: readEtaSeconds(frame),
        },
      }),

    onItemCompleted: (frame) =>
      dispatch({
        type: RESET_CAPACITY_ITEM_COMPLETED,
        payload: {
          jobId: _jobId,
          index: frame.itemIndex ?? frame.current,
          label: frame.itemLabel ?? frame.resourceName ?? frame.resourceCode ?? "",
          completedAt: frame.completedAt,
          etaSeconds: readEtaSeconds(frame),
        },
      }),

    onItemFailed: (frame) =>
      dispatch({
        type: RESET_CAPACITY_ITEM_FAILED,
        payload: {
          jobId: _jobId,
          index: frame.itemIndex ?? frame.current,
          label: frame.itemLabel ?? frame.resourceName ?? frame.resourceCode ?? "",
          completedAt: frame.completedAt,
          error: frame.error,
          etaSeconds: readEtaSeconds(frame),
        },
      }),

    onFinalizing: (frame) =>
      dispatch({ type: RESET_CAPACITY_FINALIZING, payload: finalizingPayload(_jobId, frame) }),

    onAllCompleted: (frame) =>
      dispatch({
        type: RESET_CAPACITY_ALL_COMPLETED,
        payload: {
          jobId: _jobId,
          terminatedAt: Date.now(),
          summary: frame?.itemLabel || null,
          rows: typeof frame?.result === "number" ? frame.result : null,
        },
      }),

    onAllFailed: (frame) =>
      dispatch({
        type: RESET_CAPACITY_ALL_FAILED,
        payload: { jobId: _jobId, error: frame.error, terminatedAt: Date.now() },
      }),

    onRequestError: (err) =>
      dispatch({
        type: RESET_CAPACITY_REQUEST_FAILED,
        payload: {
          jobId: _jobId,
          error: err?.response?.data?.message || err?.message || "Reset capacity request failed",
          terminatedAt: Date.now(),
        },
      }),
  });
};

// One FINALIZING frame per finalize sub-step (backend `phase`: LOADING_EXISTING_ROWS,
// WRITING_ROWS, RESEEDING_STOCK). Shared with the rehydration path so a page
// refresh during the swap keeps naming the step instead of showing a bare 100 %.
export const finalizingPayload = (jobId, frame = {}) => ({
  jobId,
  label: frame.itemLabel ?? "",
  rows: typeof frame.result === "number" ? frame.result : null,
  phase: frame.phase ?? null,
  etaSeconds: readEtaSeconds(frame),
});
